import React from 'react'
import ErrorPage from '../../components/Error'

const Error = () => {
    return (
        <ErrorPage />
    )
}

export default Error